
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

@Component({})
export default class ModalDeleteSubTask extends Vue {
  //   @Getter('getShowModalDelete', { namespace: 'entity' })
  //   showModalDelete!: boolean;
  //   @Action('setShowModalDelete', { namespace: 'entity' })
  //   setShowModalDelete!: any;
  //   @Getter('getSubTaskKey', { namespace: 'checklist' })
  //   subTaskKey!: boolean;
  //   @Action('setSubTaskKey', { namespace: 'checklist' })
  //   setSubTaskKey!: any;
  //   @Getter('getChecklistEntityStageKey', { namespace: 'checklist' })
  //   checklistEntityStageKey!: string;

  @Prop(Boolean) readonly showCancelModal!: boolean;
  @Prop(Boolean) readonly loadingCancelContract!: boolean;
  @Prop(Boolean) isAdditive!: boolean;

  cancelAditive() {
    this.$emit('cancelAditive');
  }

  cancelContract() {
    this.$emit('cancelContract');
  }

  ifCancelContractOrCancelAditive() {
    if (this.isAdditive) {
      this.cancelAditive();
    } else {
      this.cancelContract();
    }
  }

  //   @Watch('loading')
  //   handleReloadSubtaskData() {
  //     if (this.loading === false) {
  //       this.$emit('reloadSubtaskData');
  //     }
  //   }
  //   removeEntity() {
  //     this.$emit('removeEntity');
  //   }

  closeModal() {
    this.$emit('closeModal');
  }
}
